import { render } from "./DotsHorizontal.vue?vue&type=template&id=d26c08ec"
import script from "./DotsHorizontal.vue?vue&type=script&lang=js"
export * from "./DotsHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DotsHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d26c08ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d26c08ec', __exports__)) {
    api.reload('d26c08ec', __exports__)
  }
  
  module.hot.accept("./DotsHorizontal.vue?vue&type=template&id=d26c08ec", () => {
    api.rerender('d26c08ec', render)
  })

}


export default __exports__